import React, { useEffect, useContext } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import {
  SectionWrapper,
  Title,
  MobileFooter,
} from './styles/PostSaleSection.styles';
import Card from '../../_common/card/Card';
import Status from './Status';
import { handleRegStatus } from '../utilities';
import PostSaleSectionItem from './PostSaleSectionItem';
import { PROCESSED_STATUS, REGISTRATION_STATUS } from '../constants/status';
import RegistrationDocIcon from '../../../assets/RegistrationDocIcon';
import { CompletedOnSubTitle } from '../CompletedOnSubtitle';

type PostSaleSectionProps = {
  sectionItems: any[];
  status: string;
  title: string;
  subTitle?: any;
  showFooter?: boolean;
  showDesktopFooter?: boolean;
  footerContent?: any;
  isLoading: boolean;
  hasError: boolean;
  statusCode?: string;
  showProgress?: boolean;
  showEstimated?: boolean;
  hasMissingDocuments?: boolean;
  trackEventable?: boolean;
  isSelfRegistered?: boolean;
  endDate?: string;
};

const PostSaleSection = ({
  sectionItems,
  status,
  title,
  subTitle = '',
  showFooter = false,
  showDesktopFooter = false,
  footerContent = null,
  isLoading,
  hasError,
  statusCode = '',
  showProgress = true,
  showEstimated = true,
  hasMissingDocuments = false,
  trackEventable = false,
  endDate,
}: PostSaleSectionProps) => {
  const processedStatus = PROCESSED_STATUS[
    status as keyof typeof PROCESSED_STATUS
  ]
    ? status
    : handleRegStatus(status, hasMissingDocuments);
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    if (trackEventable) {
      trackEvent(
        `PostSale Section Loaded '${sectionItems[0].sectionType}'`,
        {}
      );
    }
  }, []);

  const header = {
    title: <Title>{title}</Title>,
    statusInfo: <Status status={processedStatus} />,
  };

  return (
    <SectionWrapper>
      <Card
        dataQa="vehicle-registration"
        header={header}
        headerIcon={<RegistrationDocIcon />}
      >
        {subTitle}
        {status === REGISTRATION_STATUS.COMPLETED && (
          <CompletedOnSubTitle endDate={endDate} />
        )}
        {sectionItems.map((value, index) => (
          <PostSaleSectionItem
            key={value.sectionType}
            sectionType={value.sectionType}
            sectionData={value.sectionData}
            sidebarContent={value.sidebarContent}
            isLoading={isLoading}
            hasError={hasError}
            statusCode={statusCode}
            sectionContent={value.sectionContent}
            sectionItemHeader={value.sectionItemHeader}
            showProgress={showProgress}
            isDirectlyAboveFooter={
              showFooter && index === sectionItems.length - 1
            }
            showEstimated={showEstimated}
          />
        ))}
        <MobileFooter showFooter={showFooter}>
          {footerContent && footerContent}
        </MobileFooter>
        {showDesktopFooter && footerContent && footerContent}
      </Card>
    </SectionWrapper>
  );
};

export default PostSaleSection;
